import { useRef, useState } from 'react';

const useDebouncedChange = <T>(committed: T, onChange: (value: T) => void, delayMs?: number) => {
  const [draft, setDraft] = useState<T>();
  const pending = useRef<ReturnType<typeof setTimeout>>();

  const commit = (next: T) => {
    clearTimeout(pending.current);
    setDraft(undefined);
    onChange(next);
  };

  const change = (next: T) => {
    if (delayMs === undefined) return onChange(next);
    setDraft(next);
    clearTimeout(pending.current);
    pending.current = setTimeout(() => commit(next), delayMs);
  };

  const flush = () => {
    if (draft !== undefined) commit(draft);
  };

  return { value: draft ?? committed, change, flush };
};

export default useDebouncedChange;
